import {AutogenLayoutBrokerageTrackingCredentialsPanel} from "./autogen/AutogenLayoutBrokerageTrackingCredentialsPanel";

export class BrokerageTrackingCredentialsPanel extends AutogenLayoutBrokerageTrackingCredentialsPanel
{

}
